<template>
    <v-btn id="btn-magic-mode"
           name="add-magic-mode-button"
           ref="add-magic-mode-button"
           :disabled="isDisabled"
           @click="onClick"
    >
        <v-icon size="18" class="fas fa-magic"></v-icon>

        <tippy v-if="!image" to="add-magic-mode-button" placement="right" boundary="window">
            Please load an image
            <br />
            to access editing tools
        </tippy>
        <tippy v-else-if="IDT.initial" to="add-magic-mode-button" placement="right" boundary="window">
            Please select ACES Input
            <br />
            and Output Transforms
        </tippy>
        <tippy v-else to="add-magic-mode-button" placement="right" boundary="window">
            Magic Mode
        </tippy>
    </v-btn>
</template>

<script>
import CanMixin from "@/mixins/CanMixin";
import FilenameMixin from "@/mixins/Filename";
import { mapState } from "vuex";

export default {
    mixins: [CanMixin, FilenameMixin],
    mounted() {
        this.$root.$refs.addMagicModeButton = this.$refs['add-magic-mode-button'];
    },
    computed: {
        ...mapState("App", ["IDT", "blockLoading"]),
        ...mapState("Projects", ['image']),
        isDisabled() {
            return !this.canUseColorGradingTools || this.blockLoading || !this.image || this.IDT.initial
        }
    },
    methods: {
        async onClick() {
            if (this.isDisabled) return;

            if (window.lutify.AIMagicMode.isApplied) {
                $("#blocks-container .ai-magic-mode-block").trigger("click");
            } else {
                await window._Adjustments.AIMagicMode.addBlock(window.blocks.getNewBlockNumber());
            }

			UI.toggleStartTips();

			if (window.lutify.activeSidebarContainer !== "blocks") {
                this.$store.dispatch('UI/setLeftColumn', 'appliedBlocks')
                window.UI.scrollToBlock(lutify.activeBlock);
            }
        }
    }
}
</script>